import { useMemo } from 'react'
import { TeamV2, useGetPlayerTeamsV2Query, useGetTeamsV2Query } from '../../generated/api'
import useAuth from '../../contexts/AuthContext/useAuth'

type PartialTeam = Pick<TeamV2, 'name' | 'teamId' | 'parentTeamId'>

interface UseTeamV2 {
  team?: PartialTeam
  subTeam?: PartialTeam
  hasSubTeams: boolean
}

export function useTeamV2(): UseTeamV2 {
  const { user } = useAuth()

  const playerId = user?.id
  const gameId = user?.info.gameId
  const teamName = user?.team?.name
  const yearGroup = user?.profile.ageGroup

  const { data: teams } = useGetPlayerTeamsV2Query(
    { gameId: gameId || '', playerId: playerId || '' },
    { enabled: !!gameId && !!playerId },
  )

  const team = useMemo(() => (teams?.getPlayerTeamsV2 || []).find(({ name }) => name === teamName), [teamName, teams])

  const subTeam = useMemo(
    () =>
      (teams?.getPlayerTeamsV2 || []).find(
        ({ parentTeamId, name }) => parentTeamId === team?.teamId && name === yearGroup,
      ),
    [teams, team, yearGroup],
  )

  const { data: subTeams } = useGetTeamsV2Query(
    { gameId: gameId || '', parentTeamId: team?.teamId },
    { enabled: !!gameId && !!team?.teamId },
  )

  const hasSubTeams = useMemo(() => (subTeams?.getTeamsV2 || []).length > 0, [subTeams])

  return { team, subTeam, hasSubTeams }
}
